import { useMemo } from 'react';
import { renderTorch } from '@/lib/torchSvg';
import type { TorchState, AcceptLink } from '@/lib/torchTypes';

interface TorchSvgProps {
  genesisId: string;
  chain: AcceptLink[];
  state: TorchState;
  className?: string;
}

export function TorchSvg({ genesisId, chain, state, className = '' }: TorchSvgProps) {
  const svgString = useMemo(() => {
    return renderTorch({ genesisId, chain, state });
  }, [genesisId, chain, state]);

  return (
    <div
      className={`[&>svg]:w-full [&>svg]:h-full ${className}`}
      dangerouslySetInnerHTML={{ __html: svgString }}
    />
  );
}
